var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircleWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1.688a7.312 7.312 0 1 1 0 14.625A7.312 7.312 0 0 1 9 1.688zm0 1.125a6.187 6.187 0 1 0 0 12.375A6.187 6.187 0 0 0 9 2.813zm-.783 5.106A1.125 1.125 0 0 1 9.81 9.198l-.53 2.127.025-.013a.563.563 0 1 1 .513 1.001l-.036.018a1.125 1.125 0 0 1-1.594-1.279l.53-2.126-.035.017a.562.562 0 1 1-.493-1.011l.026-.013z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 9,
    cy: 6,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleWhite);
export default __webpack_public_path__ + "static/media/info-circle-white.0463001b674e2d88417453cde0b59042.svg";
export { ForwardRef as ReactComponent };